<!-- Header -->
<div class="header center sticky-autohide" [class.transparent-light]="isTransparent">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-outfit uppercase letter-spacing-1">
        <a routerLink="/">Maximo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Creative Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Corporate Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Marketing Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Freelancer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Designer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">Startup Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-one">Portfolio One</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two">Portfolio Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three">Portfolio Three</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/"><i class="bi bi-linkedin"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one" id="home">
    <ng-template carouselSlide *ngFor="let slide of slideStore">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-image bg-overlay" style="background-image: url('{{slide.image}}')">
            <div class="section-xl bg-dark-03">
                <div class="container text-center pt-5">
                    <div class="row g-4">
                        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 z-index-1">
                            <h5 class="fw-normal mb-3 text-white">{{slide.subtitle}}</h5>
                            <h1 class="fw-bold uppercase letter-spacing-1">{{slide.title}}</h1>
                            <a class="button button-xl button-radius button-outline-white mt-3 button-font-2" routerLink="/services">Our Services</a>
                        </div>
                    </div><!-- end row -->
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->

<!-- About section -->
<div class="section-lg bg-dark">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
        <h2 class="fw-light m-0 animate-text">We truly believe that great things in business are never done by one person. They're done by a team of people.</h2>
      </div>
    </div><!-- end row(1) -->
    <div class="row g-4 mt-5 text-center">
      <div class="col-12 col-md-4 img-class" *ngFor="let service of services">
    
        <img [src]="service.img" [alt]="service.alt">
    
        <div class="mt-4">
          <h4 class="fw-normal">{{ service.title }}</h4>
    
          <p>{{ service.description }}</p>
    
          <a class="button-text-1 mt-4" [href]="service.link">
            Read More
          </a>
        </div>
    
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Portfolio section -->
<div class="section">
  <div class="container px-4">
    <div class="row gallery-wrapper g-4 border-radius">
      <div *ngFor="let item of galleryItems; let i = index" class="col-12 col-md-6 col-lg-4 gallery-box img-class">
        <div class="gallery-img" (click)="openGallery(i)" style="cursor: pointer;">
          <img [src]="item.src" [alt]="item.title" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->

<!-- Custom Lightbox Modal -->
<div *ngIf="showGalleryModal" class="gallery-modal" style="display: flex;" (click)="closeGallery()">
  <div class="gallery-modal-content" (click)="$event.stopPropagation()">
    <div class="gallery-modal-header">
      <button (click)="closeGallery()" class="gallery-modal-close">&times;</button>
    </div>
    <div class="gallery-modal-body">
      <img [src]="galleryItems[currentGalleryIndex].src" [alt]="galleryItems[currentGalleryIndex].title">
      <div class="gallery-modal-nav">
        <button (click)="previousGalleryImage()" class="gallery-nav-btn gallery-nav-prev">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="gallery-counter">{{ currentGalleryIndex + 1 }} / {{ galleryItems.length }}</span>
        <button (click)="nextGalleryImage()" class="gallery-nav-btn gallery-nav-next">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div><!-- end Custom Lightbox Modal -->
</div>
<!-- end Portfolio section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url(assets/images/backgrounds/main-bg-1.jpg);">
  <div class="bg-dark-03">
    <div class="container text-center">
      <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
        <i class="bi bi-play"></i>
      </a>
    </div><!-- end container -->
  </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Clients section -->
<div class="section-sm bg-dark">
  <div class="container">
    <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr brands-carousel">
        <ng-template carouselSlide *ngFor="let brand of brandStore">
            <div class="client-box">
                <a href="#."><img src="assets/images/brands/{{brand.img}}" alt="brand-img"></a>
            </div>
        </ng-template>
    </owl-carousel-o>
  </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="fw-normal display-6">Get <span class="text-highlight-gradient">In</span> Touch</h2>
                </div>
            </div>
        </div>
        <div class="row g-4">
            <!-- Contact Info -->
            <div class="col-12 col-md-4">
                <div class="mb-4">
                    <h6 class="fw-semi-bold m-0">Phone:</h6>
                    <p>+(1) 234 567 89</p>
                </div>
                <div class="mb-4">
                    <h6 class="fw-semi-bold m-0">Email:</h6>
                    <p>yoursite&#64;domain.com</p>
                </div>
                <div>
                    <h6 class="fw-semi-bold m-0">Address:</h6>
                    <p>Patton Street Caulfield East VIC 3145</p>
                </div>
            </div>
            <!-- Contact Form -->
            <div class="col-12 col-md-8">
                <div class="contact-form text-start">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                </div>
            </div>
            <!-- end Contact Form -->
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->